import actions from "./actions";

let product, products, idx;

const initProductCard = {
    id: null,
    readProductState: false,
    product: {},
    readPastTransactionState: false,
    pastTransactions: [],
};

const initState = {
    productCreateState: false,
    productCreateResult: {},
    productCreateMultipleState: null,
    productImportState: false,
    productReadAllState: false,
    productReadState: false,
    productUpdateState: false,
    productUpdateResult: {},
    productArchiveState: false,
    productArchiveResult: {},
    deleteState: false,
    products: [],
    pagination: {},
    product: {
        name: null,
        sku: null,
        barcode: null,
        is_selling: null,
        sale_description: null,
        sale_price: null,
        sale_prices: [],
        sale_account_id: null,
        sale_tax_code_id: null,
        is_buying: null,
        purchase_description: null,
        purchase_price: null,
        purchase_prices: [],
        purchase_account_id: null,
        purchase_tax_code_id: null,
        track_inventory: null,
        inventory_account_id: null,
        product_unit_id: [],
        remarks: null,
        classification_code: null,
    },

    productCard: initProductCard,
    mergeState: false,
    selectedProductIds: [],

    productName: null,
    isSelling: null,
    isBuying: null,
    trackInventory: null,
    showSaleCustomPrices: null,
    showPurchaseCustomPrices: null,

    // bulk update product
    readBulkProductsState: false,
    bulkProducts: [],
    bulkProductsPagination: {},
    bulkUpdateProductsState: false,
    bulkUpdateProductsResult: {},

    // Obsolete
    createProductStatus: false, // request, success, error
    updateProductStatus: false,
    archiveProductStatus: false,

    importHeaderRowLineCount: 0,

    // bulk delete products
    bulkDeleteProductsState: false,
    bulkDeleteProductsResult: {
        deletedCnt: 0,
        undeletable: [],
    },
    bulkDeleteProductsError: "",
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.CREATE_PRODUCT_REQUEST:
            return {
                ...state,
                createProductStatus: 'request', //OBSOLETE
                productCreateState: 'request',
            };
        case actions.CREATE_PRODUCT_SUCCESS:
            return {
                ...state,
                createProductStatus: 'success', //OBSOLETE
                productCreateState: 'success',
                productCreateResult: action.product,
            };
        case actions.CREATE_PRODUCTS_REQUEST:
            return {
                ...state,
                productCreateMultipleState: 'request',
            };
        case actions.CREATE_PRODUCTS_SUCCESS:
            return {
                ...state,
                productCreateMultipleState: 'success',
            };
        case actions.READ_PRODUCTS_REQUEST:
            return {
                ...state,
                productReadAllState: 'request',
            };
        case actions.READ_PRODUCTS_SUCCESS:
            return {
                ...state,
                productReadAllState: 'success',
                products: action.products,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.SET_PRODUCT_IN_SET: // Update by ID
            products = [...state.products];
            idx = products.findIndex(item => item.id === action.product.id);

            // Merge
            products[idx] = action.product;

            return {
                ...state,
                products,
            };
        case actions.READ_PRODUCT_REQUEST:
            return {
                ...state,
                productReadState: 'request',
            };
        case actions.READ_PRODUCT_SUCCESS: {
            const product = { ...action.product };
            // TODO REMOVE WHEN BACKEND READY:
            product.units = product.units?.map(unit => ({
                ...unit,
                line: unit.id,
            }));

            return {
                ...state,
                productReadState: 'success',
                product,
                productName: product.name,
                isSelling: product.is_selling,
                isBuying: product.is_buying,
                trackInventory: product.track_inventory,
                showSaleCustomPrices: product.sale_prices.length >= 1,
                showPurchaseCustomPrices: product.purchase_prices.length >= 1,
            };
        }
        case actions.UPDATE_PRODUCT_REQUEST:
            return {
                ...state,
                productUpdateState: 'request',
                updateProductStatus: 'request', //OBSOLETE
            };
        case actions.UPDATE_PRODUCT_SUCCESS:
            return {
                ...state,
                productUpdateState: 'success',
                productUpdateResult: action.product,
                updateProductStatus: 'success', //OBSOLETE
            };
        case actions.ARCHIVE_PRODUCT_REQUEST:
            return {
                ...state,
                productArchiveState: 'request',
                archiveProductStatus: 'request', //OBSOLETE
            };
        case actions.ARCHIVE_PRODUCT_SUCCESS:
            return {
                ...state,
                productArchiveState: 'success',
                productArchiveResult: action.product,
                archiveProductStatus: 'success', //OBSOLETE
            };
        case actions.DELETE_PRODUCT_REQUEST:
            return {
                ...state,
                deleteState: 'request',
            };
        case actions.DELETE_PRODUCT_SUCCESS:
            return {
                ...state,
                deleteState: 'success',
            };

        // bulk update product
        case actions.BULK_UPDATE_PRODUCTS_REQUEST:
            return {
                ...state,
                bulkUpdateProductsState: 'request',
            };
        case actions.BULK_UPDATE_PRODUCTS_SUCCESS:
            return {
                ...state,
                bulkUpdateProductsState: 'success',
                bulkUpdateProductsResult: action.result,
            };
        case actions.BULK_UPDATE_PRODUCTS_ERROR:
            return {
                ...state,
                bulkUpdateProductsState: 'error',
            };
        case actions.READ_BULK_PRODUCTS_REQUEST:
            return {
                ...state,
                readBulkProductsState: 'request',
            };
        case actions.READ_BULK_PRODUCTS_SUCCESS:
            return {
                ...state,
                readBulkProductsState: 'success',
                bulkProducts: action.products,
                bulkProductsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.READ_BULK_PRODUCTS_ERROR:
            return {
                ...state,
                readBulkProductsState: 'error',
            };

        case actions.CHANGE_PRODUCT:
            product = {
                ...(action.reset ? initState.product : state.product),
                ...action.request,
            };

            if (!product.is_selling) {
                product.sale_description = null;
                product.sale_price = null;
                product.sale_account_id = null;
                product.default_sales_tax_code_id = null;
            }
            if (!product.is_buying) {
                product.purchase_description = null;
                product.purchase_price = null;
                product.purchase_account_id = null;
            }
            if (!product.track_inventory)
                product.inventory_account_id = null;

            return {
                ...state,
                product,
                productName: product.name,
                isSelling: product.is_selling,
                isBuying: product.is_buying,
                trackInventory: product.track_inventory,
            };
        case actions.CHANGE_IS_SELLING:
            return {
                ...state,
                isSelling: action.isSelling,
            };
        case actions.CHANGE_IS_BUYING:
            return {
                ...state,
                isBuying: action.isBuying,
            };
        case actions.CHANGE_SHOW_CUSTOM_SALE_PRICES:
            return {
                ...state,
                showSaleCustomPrices: action.isEnabled,
            };
        case actions.CHANGE_SHOW_CUSTOM_PURCHASE_PRICES:
            return {
                ...state,
                showPurchaseCustomPrices: action.isEnabled,
            };
        case actions.PRODUCT_SET_TRACK_INVENTORY:
            return {
                ...state,
                trackInventory: action.trackInventory,
            };
        case actions.PRODUCT_RESET_STATE:
            return {
                ...state,
                product: initState.product,
            };

        case actions.OPEN_PRODUCT_CARD_REQUEST:
            return { ...state,
                productCard: { ...state.productCard,
                    readProductState: 'request',
                    id: action.id,
                    product: {},
                    productName: null,
                }};
        case actions.OPEN_PRODUCT_CARD_SUCCESS:
            return { ...state,
                productCard: { ...state.productCard,
                    readProductState: 'success',
                    product: action.product,
                    productName: action.product.name,
                }};
        case actions.OPEN_PRODUCT_CARD_ERROR:
            return { ...state,
                productCard: { ...state.productCard,
                    readProductState: 'error',
                }};
        case actions.READ_PRODUCT_CARD_PAST_TXNS_REQUEST:
            return { ...state,
                productCard: { ...state.productCard,
                    readPastTransactionState: 'request',
                    id: action.id,
                }};
        case actions.READ_PRODUCT_CARD_PAST_TXNS_SUCCESS:
            return { ...state,
                productCard: { ...state.productCard,
                    readPastTransactionState: 'success',
                    pastTransactions: action.pastTransactions,
                }};
        case actions.READ_PRODUCT_CARD_PAST_TXNS_ERROR:
            return { ...state,
                productCard: { ...state.productCard,
                    readPastTransactionState: 'error',
                }};
        case actions.CLOSE_PRODUCT_CARD:
            return { ...state, productCard: {...initProductCard} };
        case actions.MERGE_PRODUCT_REQUEST:
            return {
                ...state,
                mergeState: 'request',
            };
        case actions.MERGE_PRODUCT_SUCCESS:
            return {
                ...state,
                mergeState: 'success',
            };
        case actions.MERGE_PRODUCT_ERROR:
            return {
                ...state,
                mergeState: 'error',
            };
        case actions.SET_PRODUCT_TABLE_IDS:
            return {
                ...state,
                selectedProductIds: action.ids,
            };

        case actions.PRODUCT_SET_NAME:
            return {
                ...state,
                productName: action.name,
            };
        case actions.PRODUCT_SET_CLASSIFICATION_CODE:
            return {
                ...state,
                product: {
                    ...state.product,
                    classification_code: action.classificationCode,
                },
            };

        case actions.SET_IMPORT_HEADER_ROW_LINE_COUNT:
            return {
                ...state,
                importHeaderRowLineCount: action.count,
            };

        case actions.BULK_DELETE_PRODUCTS_REQUEST:
            return {
                ...state,
                bulkDeleteProductsState: "request",
            };
        case actions.BULK_DELETE_PRODUCTS_SUCCESS:
            return {
                ...state,
                bulkDeleteProductsState: "success",
                bulkDeleteProductsResult: action.data,
            };
        case actions.BULK_DELETE_PRODUCTS_ERROR:
            return {
                ...state,
                bulkDeleteProductsState: "error",
                bulkDeleteProductsError: action.error.message || "An error occurred while deleting products.",
            };

        default:
            return state;
    }
}
